<template>
  <div>
    <div class="sample float-left" :style="`background: ${color}`"></div> {{title}}
  </div>
</template>

<script>
export default {
  name: "ApexCustomLabel",
  props: {
    color: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.sample {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}
</style>
